import NextImage from 'next/image';
import addImg from 'images/banner/upc_sk_780x500.jpg';

export const GalleryUPC = () => (
    <>
        <a
            href="https://ad.doubleclick.net/ddm/trackclk/N33505.1920760BEZREALITKY0/B22201594.245485075;dc_trk_aid=442166096;dc_trk_cid=115352760;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua"
            target="_blank"
        >
            <NextImage src={addImg} placeholder="blur" alt="UPC" />
        </a>
        <img
            src="https://ad.doubleclick.net/ddm/trackimp/N33505.1920760BEZREALITKY0/B22201594.245485075;dc_trk_aid=442166096;dc_trk_cid=115352760;ord=%%ADFRND%%;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?"
            height="1"
            width="1"
            alt="Advertisement"
        />
    </>
);
